module.exports = __webpack_public_path__ + "img/nightmare_before_xmas.84e849df.jpg";